"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.724 2.903C16.832 2.902 21 6.96 21 11.999c0 5.038-4.165 9.098-9.273 9.098-3.767.001-7.016-2.203-8.467-5.377a.7.7 0 0 1 1.273-.582c1.227 2.683 3.983 4.56 7.194 4.56 4.363-.001 7.874-3.462 7.873-7.7 0-4.237-3.513-7.696-7.876-7.695A7.94 7.94 0 0 0 5.5 7.286h2.14a.7.7 0 1 1 0 1.4H4.203a.71.71 0 0 1-.02 0H3.7a.7.7 0 0 1-.7-.7V4.147a.7.7 0 1 1 1.4 0V6.42c1.741-2.2 4.437-3.517 7.324-3.517ZM12 6.444a.7.7 0 0 1 .7.7v5.073a.7.7 0 0 1-.387.626l-4.611 2.305a.7.7 0 0 1-.626-1.252l4.224-2.112v-4.64a.7.7 0 0 1 .7-.7Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HistoryIcon24.js.map